import React from "react";

import { generatePath, NavigateFunction } from "react-router-dom";

import * as Styled from "./CrashReportPageNavigationContent.styles";
import { CrashReport } from "../../../../../../common/models/crashReporting";
import identifiers from "../../../../../../common/util/identifiers.json";
import { RoutePaths } from "../../../../../router/config/routePaths";

interface Props {
  crashReport?: CrashReport;
  selectedWorkspaceSlug?: string;
  selectedAppKey?: string;
  navigate: NavigateFunction;
}

export default function CrashReportPageNavigationContent({
  crashReport,
  selectedWorkspaceSlug,
  selectedAppKey,
  navigate,
}: Props) {
  if (!selectedWorkspaceSlug || !selectedAppKey || !crashReport) {
    return <></>;
  }

  const commonParamValues = {
    workspaceSlug: selectedWorkspaceSlug,
    appKey: selectedAppKey,
    crashReportKey: crashReport.key.toString(),
  };

  const allEventsPath = generatePath(RoutePaths.CRASH_REPORT_EVENT, {
    ...commonParamValues,
    crashReportEventId: crashReport.last_event,
  });
  const crashOverviewPath = generatePath(RoutePaths.CRASH_REPORT_OVERVIEW, commonParamValues);

  const isOverviewClicked = window.location.pathname.includes("overview");

  return (
    <Styled.CrashNavigationLinksWrapper>
      <Styled.CrashNavigationLinkWrapper
        $active={isOverviewClicked}
        onClick={() => navigate(crashOverviewPath)}
        data-testid={identifiers["navbar.crashReport.overview"]}
      >
        {"Overview"}
      </Styled.CrashNavigationLinkWrapper>
      <Styled.CrashNavigationLinkWrapper
        $active={!isOverviewClicked}
        onClick={() => navigate(allEventsPath)}
        data-testid={identifiers["navbar.crashReport.allEvents"]}
      >
        {"All events"}
      </Styled.CrashNavigationLinkWrapper>
    </Styled.CrashNavigationLinksWrapper>
  );
}
